import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../services/IFilter";

export class CmdbHardwareRequestFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

 requestNumberChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get requestNumber():any {
    return this.requestNumberChange.value;
  }
  set requestNumber(value:any) {
    this.requestNumberChange.next(value);
    this.emitChange("requestNumber", value);
  }

  requestedByChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get requestedBy():any {
    return this.requestedByChange.value;
  }
  set requestedBy(value:any) {
    this.requestedByChange.next(value);
    this.emitChange("requestedBy", value);
  }

  applicationChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get application():any {
    return this.applicationChange.value;
  }
  set application(value:any) {
    this.applicationChange.next(value);
    this.emitChange("application", value);
  }

  applicationTagChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get applicationTag():any {
    return this.applicationTagChange.value;
  }
  set applicationTag(value:any) {
    this.applicationTagChange.next(value);
    this.emitChange("applicationTag", value);
  }

  classCodeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get classCode():any {
    return this.classCodeChange.value;
  }
  set classCode(value:any) {
    this.classCodeChange.next(value);
    this.emitChange("classCode", value);
  }

  environmentChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get environment():any {
    return this.environmentChange.value;
  }
  set environment(value:any) {
    this.environmentChange.next(value);
    this.emitChange("environment", value);
  }

  serverSizeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get serverSize():any {
    return this.serverSizeChange.value;
  }
  set serverSize(value:any) {
    this.serverSizeChange.next(value);
    this.emitChange("serverSize", value);
  }

  serverTypeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get serverType():any {
    return this.serverTypeChange.value;
  }
  set serverType(value:any) {
    this.serverTypeChange.next(value);
    this.emitChange("serverType", value);
  }

  osTypeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osType():any {
    return this.osTypeChange.value;
  }
  set osType(value:any) {
    this.osTypeChange.next(value);
    this.emitChange("osType", value);
  }

  osChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get os():any {
    return this.osChange.value;
  }
  set os(value:any) {
    this.osChange.next(value);
    this.emitChange("os", value);
  }

  osVersionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osVersion():any {
    return this.osVersionChange.value;
  }
  set osVersion(value:any) {
    this.osVersionChange.next(value);
    this.emitChange("osVersion", value);
  }

  siteChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get site():any {
    return this.siteChange.value;
  }
  set site(value:any) {
    this.siteChange.next(value);
    this.emitChange("site", value);
  }

  cpuChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get cpu():any {
    return this.cpuChange.value;
  }
  set cpu(value:any) {
    this.cpuChange.next(value);
    this.emitChange("cpu", value);
  }

  ramChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get ram():any {
    return this.ramChange.value;
  }
  set ram(value:any) {
    this.ramChange.next(value);
    this.emitChange("ram", value);
  }

  projectNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get projectName():any {
    return this.projectNameChange.value;
  }
  set projectName(value:any) {
    this.projectNameChange.next(value);
    this.emitChange("projectName", value);
  }

  projectManagerContactChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get projectManagerContact():any {
    return this.projectManagerContactChange.value;
  }
  set projectManagerContact(value:any) {
    this.projectManagerContactChange.next(value);
    this.emitChange("projectManagerContact", value);
  }

  hostingPlatformChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get hostingPlatform():any {
    return this.hostingPlatformChange.value;
  }
  set hostingPlatform(value:any) {
    this.hostingPlatformChange.next(value);
    this.emitChange("hostingPlatform", value);
  }

  clusterChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get cluster():any {
    return this.clusterChange.value;
  }
  set cluster(value:any) {
    this.clusterChange.next(value);
    this.emitChange("cluster", value);
  }

  serverNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get serverName():any {
    return this.serverNameChange.value;
  }
  set serverName(value:any) {
    this.serverNameChange.next(value);
    this.emitChange("serverName", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.requestNumber && this.requestNumber !== '') {
      params = params.set("requestNumber", this.requestNumber);
    }
    if (this.requestedBy && this.requestedBy !== '') {
      params = params.set("requestedBy", this.requestedBy);
    }
    if (this.application && this.application !== '') {
      params = params.set("application", this.application);
    }
    if (this.applicationTag && this.applicationTag !== '') {
      params = params.set("applicationTag", this.applicationTag);
    }
    if (this.classCode && this.classCode !== '') {
      params = params.set("classCode", this.classCode);
    }
    if (this.environment && this.environment !== '') {
      params = params.set("environment", this.environment);
    }
    if (this.serverSize && this.serverSize !== '') {
      params = params.set("serverSize", this.serverSize);
    }
    if (this.serverType && this.serverType !== '') {
      params = params.set("serverType", this.serverType);
    }
    if (this.osType && this.osType !== '') {
      params = params.set("osType", this.osType);
    }
    if (this.os && this.os !== '') {
      params = params.set("os", this.os);
    }
    if (this.osVersion && this.osVersion !== '') {
      params = params.set("osVersion", this.osVersion);
    }
    if (this.site && this.site !== '') {
      params = params.set("site", this.site);
    }
    if (this.cpu && this.cpu !== '') {
      params = params.set("cpu", this.cpu);
    }
    if (this.ram && this.ram !== '') {
      params = params.set("ram", this.ram);
    }
    if (this.projectName && this.projectName !== '') {
      params = params.set("projectName", this.projectName);
    }
    if (this.projectManagerContact && this.projectManagerContact !== '') {
      params = params.set("projectManagerContact", this.projectManagerContact);
    }
    if (this.hostingPlatform && this.hostingPlatform !== '') {
      params = params.set("hostingPlatform", this.hostingPlatform);
    }
    if (this.cluster && this.cluster !== '') {
      params = params.set("cluster", this.cluster);
    }
    if (this.serverName && this.serverName !== '') {
      params = params.set("serverName", this.serverName);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId || undefined);
    this.requestNumberChange.next(props.requestNumber || undefined);
    this.requestedByChange.next(props.requestedBy || undefined);
    this.applicationChange.next(props.application || undefined);
    this.applicationTagChange.next(props.applicationTag || undefined);
    this.classCodeChange.next(props.classCode || undefined);
    this.environmentChange.next(props.environment || undefined);
    this.serverSizeChange.next(props.serverSize || undefined);
    this.serverTypeChange.next(props.serverType || undefined);
    this.osTypeChange.next(props.osType || undefined);
    this.osChange.next(props.os || undefined);
    this.osVersionChange.next(props.osVersion || undefined);
    this.siteChange.next(props.site || undefined);
    this.cpuChange.next(props.cpu || undefined);
    this.ramChange.next(props.ram || undefined);
    this.projectNameChange.next(props.projectName || undefined);
    this.projectManagerContactChange.next(props.projectManagerContact || undefined);
    this.hostingPlatformChange.next(props.hostingPlatform || undefined);
    this.clusterChange.next(props.cluster || undefined);
    this.serverNameChange.next(props.serverName || undefined);
  }

  toObj() {
    let obj:any = {};

    obj.companyId = this.companyId;
    obj.requestNumber = this.requestNumber;
    obj.requestedBy = this.requestedBy;
    obj.application = this.application;
    obj.applicationTag = this.applicationTag;
    obj.classCode = this.classCode;
    obj.environment = this.environment;
    obj.serverSize = this.serverSize;
    obj.serverType = this.serverType;
    obj.osType = this.osType;
    obj.os = this.os;
    obj.osVersion = this.osVersion;
    obj.site = this.site;
    obj.cpu = this.cpu;
    obj.ram = this.ram;
    obj.projectName = this.projectName;
    obj.projectManagerContact = this.projectManagerContact;
    obj.hostingPlatform = this.hostingPlatform;
    obj.cluster = this.cluster;
    obj.serverName = this.serverName;

    return obj;
  }

  public clear():void {
    this.companyId = undefined;
    this.requestNumber = undefined;
    this.requestedBy = undefined;
    this.application = undefined;
    this.applicationTag = undefined;
    this.classCode = undefined;
    this.environment = undefined;
    this.serverSize = undefined;
    this.serverType = undefined;
    this.osType = undefined;
    this.os = undefined;
    this.osVersion = undefined;
    this.site = undefined;
    this.cpu = undefined;
    this.ram = undefined;
    this.projectName = undefined;
    this.projectManagerContact = undefined;
    this.hostingPlatform = undefined;
    this.cluster = undefined;
    this.serverName = undefined;
  }
}
